<template>
  <transition-group name="list" :tag="tag">
    <slot></slot>
  </transition-group>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: "div",
    },
  },
};
</script>
<style lang="scss">
.list-enter-active{
  transition: all 125ms;
}
.list-leave-active {
  transition: all 200ms;
}
.list-enter {
  opacity: 0;
}

.list-leave-to {
  opacity: 0;
}
</style>